import { Shipment, ShipmentResponse, ShipmentUpdate } from "@cnx/common";
import { ComboboxItem } from "@mantine/core";
import i18n from "common/i18n";
import { useShippingManagementStore } from "stores/shippingManagement";
import { ShipmentParams } from "types/Shipment";
import api from "../api";

class ShipmentService {
  static async getShipments({
    tripIdQuery = "",
    truckQuery = "",
    trailerQuery = "",
    driverQuery = "",
    completed,
    fromDate,
    toDate,
  }: ShipmentParams) {
    const { data } = await api.get<ShipmentResponse>("/shipments", {
      params: {
        tripIdQuery,
        truckQuery,
        trailerQuery,
        driverQuery,
        completed,
        fromDate,
        toDate,
        translation: i18n.language,
      },
    });
    return data.shipments;
  }

  static async getShipmentByResourceCombinationId(
    resourceCombinationId: string
  ) {
    const { data } = await api.get<Shipment>(
      `/shipments/${resourceCombinationId}`,
      {
        params: { translation: i18n.language },
      }
    );
    return data;
  }

  static async updateShipment(
    resourceCombinationId: string,
    update: ShipmentUpdate
  ) {
    const location = useShippingManagementStore.getState().location;

    const { data } = await api.patch<Shipment>(
      `/shipments/${resourceCombinationId}`,
      {
        ...update,
        location: location || {},
      }
    );
    return data;
  }

  static async getShipmentOptions() {
    const { data } = await api.get<ComboboxItem[]>("/shipments/options");
    return data;
  }
}

export default ShipmentService;
